import React, {useState,useEffect} from "react";
import { Button, Stack, CardContent, Typography, TextField,Grid,Box} from "@mui/material";
import { useFormik, Form, FormikProvider,getIn, Field, ErrorMessage} from "formik";
import { useSnackbar } from "notistack";
import authServices from '../../services/authServices';
import { useNavigate, useParams } from 'react-router-dom';
// import UploadMneomonic from "../../pages/landing/uploadMneomonic.js";
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import SuccessOptedIn from '../../components/modals/successOptedIn.js';
import AlReadyOptedInMsg from '../../components/modals/alReadyOptedInMsg.js';
import AlgoErrorMsg from "../../components/modals/algoErrorMsg.js";
import * as Yup from "yup"
import listingService from "../../services/listingServices.js";
import CustomDropZoneDoc from '../../components/customDropZoneDoc';
import Dialog from '@mui/material/Dialog';
import WrongMnemonicErrorMsg from '../../components/modals/wrongMnemonicErrorMsg.js';
import ErrorModal from "./errorModal.js";


function UploadMneomonic({open,setOpen, dltAccount, userId, assetId , onOptinSuccess}) {
    const [successModal ,setSuccessModal]=useState(false);
    const [alreadyOptedIn,setAlreadyOptedIn]=useState(false);
    const [wrongMnemonicError,setWrongMnemonicError]=useState(false);
    const [algoErrorMsg ,setAlgoErrorMsg]=useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [openError, setOpenError] = useState(false);
    const { enqueueSnackbar } = useSnackbar()
    const navigate = useNavigate()

    const SUPPORTED_FORMATS = ["text/plain"]
    const docSchema = Yup.object().shape({
        txt:Yup.mixed().nullable().required("Document Is Required").test("FILE_SIZE", "Uploaded file is too big.", value => value && value.size <= 16384 * 16384).test("FILE_FORMAT", "Uploaded file has unsupported format.", value => value && SUPPORTED_FORMATS.includes(value.type)),
    })
    const formik = useFormik({
        initialValues:{
            txt:null
        },
        validationSchema: docSchema,
        onSubmit: (v) => {
                const reader = new FileReader();
                reader.onload = () => {
                submitEncryptedText({fileContent: reader.result, userId, assetId, dltAccount});
                };
                reader.readAsText(v.txt);
            }
        })
    
        const {errors,touched,values,handleSubmit,getFieldProps,setFieldValue,resetForm} = formik

        
        const onClose=()=>{
            setOpen(false);
            resetForm()
        }

        async function submitEncryptedText(data){
        try{  
            let res = await authServices.submitEncryptedText(data);
            if(res && res.success){
                if(res?.isOptinCompletedAlready) setAlreadyOptedIn(true);
                else if(res?.isWrongEncryptedFile) setWrongMnemonicError(true);
                else setSuccessModal(true);
            }
            else{
                // setErrorMessage(res?.message || "Something went wrong");
                // setOpenError(true);   // your new modal
                // Handle response with error structure
            if (res?.message) {
                setErrorMessage(res?.message || "Something went wrong");
                setOpenError(true);   // your new modal
            } else {
                setAlgoErrorMsg(true); // fallback for 500 or unknown
            }
            }
        }
            catch(err){
                console.log(err)
                setAlgoErrorMsg(true);
            }
        }
        

  return (
    <>
    <AlReadyOptedInMsg open={alreadyOptedIn} handleClose={()=>{setAlreadyOptedIn(false);}} />
    <SuccessOptedIn open={successModal} handleClose={()=>{onOptinSuccess();setSuccessModal(false);}}/>
    <WrongMnemonicErrorMsg open={wrongMnemonicError} handleClose={()=>{setWrongMnemonicError(false)}}/>
    <ErrorModal open={openError} handleClose={() => {setErrorMessage(""); setOpenError(false);}} message={errorMessage}/>    
    <AlgoErrorMsg open={algoErrorMsg} handleClose={()=>{setAlgoErrorMsg(false);}} />  
    <Dialog     
    open={open}
    onClose={onClose}
    fullWidth={true}
    maxWidth={'sm'}
    >
       <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <CardContent sx={{margin:'20px 50px'}} >
                    <Stack spacing={3} >
                        <Stack direction={'row'} justifyContent='space-between' alignItems={'center'} >
                            <Typography variant="h4" color={"#2D2F39"}>Upload Encrypted Mneomonic File</Typography>
                        </Stack>
                        <Box>
                            {/* <Typography variant='subHeading'>Upload Transaction Proof</Typography> */}
                            <CustomDropZoneDoc setter={(file) =>{setFieldValue(`txt`,file)}} errors={getIn(touched,`txt`) &&
                                    getIn(errors,`txt`)}
                                    files={values?.txt}
                                    edit={true}
                                    />
                        </Box>
                        <Stack direction={'row'} spacing={1}>
                            <Button type='submit' variant="contained" sx={{ py: 1, px: 3,width:'20%'}}>Submit</Button>
                            <Button variant="outlined" onClick={()=>onClose()} sx={{ py: 1, px: 3,width:'20%'}}>Cancel</Button>
                        </Stack>
                    </Stack>
                </CardContent>
            </Form>
       </FormikProvider>
    </Dialog>
    </>
  );
}

export default function AssetOptin ({id , onOptinSuccess}) {
    // console.log("id" , id)
    // const { id } = useParams();
    const dltAccount = id.split("&")[0];
    const userId = id.split("&")[1];
    const assetId = +id.split("&")[2];
    const { enqueueSnackbar } = useSnackbar()
    const navigate = useNavigate()
    const [successModal ,setSuccessModal]=useState(false);
    const [alreadyOptedIn,setAlreadyOptedIn]=useState(false);
    const [algoErrorMsg ,setAlgoErrorMsg]=useState(false);
    const [assetName,setAssetName]=useState("");
    useEffect(()=>{
        const getAssetName = async () => {
            try{
            let res = await     listingService.getListingByAssetId(assetId)
        if(res && res.success){
                setAssetName(res.data);
            }
            }catch(err){
                console.log(err);
            }
        }
        getAssetName();
    },[assetId]);     

    const optinValidationSchema=Yup.object().shape({
        mneomonic1: Yup.string().required('Field is required'),
        mneomonic2: Yup.string().required('Field is required'),
        mneomonic3: Yup.string().required('Field is required'),
        mneomonic4: Yup.string().required('Field is required'),
        mneomonic5: Yup.string().required('Field is required'),
        mneomonic6: Yup.string().required('Field is required'),
        mneomonic7: Yup.string().required('Field is required'),
        mneomonic8: Yup.string().required('Field is required'),
        mneomonic9: Yup.string().required('Field is required'),
        mneomonic10: Yup.string().required('Field is required'),
        mneomonic11: Yup.string().required('Field is required'),
        mneomonic12: Yup.string().required('Field is required'),
        mneomonic13: Yup.string().required('Field is required'),
        mneomonic14: Yup.string().required('Field is required'),
        mneomonic15: Yup.string().required('Field is required'),
        mneomonic16: Yup.string().required('Field is required'),
        mneomonic17: Yup.string().required('Field is required'),
        mneomonic18: Yup.string().required('Field is required'),
        mneomonic19: Yup.string().required('Field is required'),
        mneomonic20: Yup.string().required('Field is required'),
        mneomonic21: Yup.string().required('Field is required'),
        mneomonic22: Yup.string().required('Field is required'),
        mneomonic23: Yup.string().required('Field is required'),
        mneomonic24: Yup.string().required('Field is required'),
        mneomonic25: Yup.string().required('Field is required'),
       
    })

    const [open,setOpen] = useState(false);

    const formik = useFormik({
            initialValues:{
                mneomonic1: '',
                mneomonic2: '',
                mneomonic3: '',
                mneomonic4: '',
                mneomonic5: '',
                mneomonic6: '',
                mneomonic7: '',
                mneomonic8: '',
                mneomonic9: '',
                mneomonic10: '',
                mneomonic11: '',
                mneomonic12: '',
                mneomonic13: '',
                mneomonic14: '',
                mneomonic15: '',
                mneomonic16: '',
                mneomonic17: '',
                mneomonic18: '',
                mneomonic19: '',
                mneomonic20: '',
                mneomonic21: '',
                mneomonic22: '',
                mneomonic23: '',
                mneomonic24: '',
                mneomonic25: '',
              },
              validationSchema:optinValidationSchema,
       
        onSubmit: (v) => {
                const mneomonic = [v.mneomonic1, v.mneomonic2,
                    v.mneomonic3, v.mneomonic4, v.mneomonic5,
                    v.mneomonic6, v.mneomonic7, v.mneomonic8,
                    v.mneomonic9, v.mneomonic10, v.mneomonic11,
                    v.mneomonic12, v.mneomonic13, v.mneomonic14,
                    v.mneomonic15, v.mneomonic16, v.mneomonic17,
                    v.mneomonic18, v.mneomonic19, v.mneomonic20,
                    v.mneomonic21, v.mneomonic22, v.mneomonic23,
                    v.mneomonic24, v.mneomonic25
                ];
                sendMneomonic({mneomonic, userId, assetId, dltAccount})
            }
        })
    
        const {errors,touched,values,handleSubmit,getFieldProps,setFieldValue,resetForm} = formik
        
        const onClose=()=>{
            // setOpen(false);
            resetForm()
        }

        async function sendMneomonic (data) {
            let res = await authServices.submitMneomonic(data);
            if(res && res.success){
                if(res?.isOptinCompletedAlready) setAlreadyOptedIn(true);
                else setSuccessModal(true);
            }
            else{
                setAlgoErrorMsg(true);
            }
        }

  return (
    <Box sx={{py:1,bgcolor:"#fff",height:{lg:'100vh',xs:'100%',background: 'linear-gradient(to bottom, #FFF 0%,#F2F3F4 100%)'}}}>
        <AlReadyOptedInMsg open={alreadyOptedIn} handleClose={()=>{setAlreadyOptedIn(false);}} />
        <SuccessOptedIn open={successModal} handleClose={()=>{onOptinSuccess();setSuccessModal(false); }}/>
        <AlgoErrorMsg open={algoErrorMsg} handleClose={()=>{setAlgoErrorMsg(false);}} />  
        <Stack spacing={1}  sx={{px:{ lg:"200px",md:"80px"}}}>
            <Stack direction={"row"} spacing={"90px"} flex={1} alignItems={"center"}>
               <Box  sx={{height:{md:44,xs:24},cursor:"pointer",ml:{xl:'98px',lg:'40px',md:'40px',sm:'50px',xs:'20px'}}} component={"img"} src={"/assets/images/logo.png"}></Box>
            </Stack>
            <Box sx={{display:"flex",flexDirection:"column",gap:1,py:3}}>
                <Stack direction={"row"} spacing={1}>
                <Typography sx={{fontWeight:500}}>Asset Id :</Typography> <Typography  color={"#2D2F39"}> {assetId}</Typography> 
                </Stack>
                <Stack direction={"row"} spacing={1}>
                <Typography sx={{fontWeight:500}}>Asset Name:</Typography> <Typography  color={"#2D2F39"}> {assetName?.title}</Typography> 
                </Stack>
            </Box>
            <Stack spacing={0} direction={'row'} justifyContent='center' alignItems={'center'} >
               <KeyboardIcon sx={{mr:1,fontSize:40,color:'#fcda04'}}/>
               <Typography variant="aboutHeading2" color={"#2D2F39"}>Enter Receiver Algorand Account Mnemonic</Typography>
            </Stack>
            <FormikProvider value={formik}>
                <UploadMneomonic open={open} setOpen={setOpen} dltAccount={dltAccount} userId={userId} assetId={assetId} onOptinSuccess={onOptinSuccess}/>
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                 
                    <Stack  spacing={1}  justifyContent={"center"}>
                         
                        <Stack sx={{justifyContent: "center",pt:2, }}>
                        <Grid container spacing={2} sx={{gap: {xl:"2px",lg:"2px",xs:"1px"}, paddingLeft: "0px"}} justifyContent={"center"}>

                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield" as={TextField} sx={{'& .MuiInputBase-root': {minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px",color:'#000'}}  name="mneomonic1" type="text" />
                         <ErrorMessage name="mneomonic1" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>

                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic2" type="text" />
                         <ErrorMessage name="mneomonic2" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>

                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic3" type="text" />
                         <ErrorMessage name="mneomonic3" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>

                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic4" type="text" />
                         <ErrorMessage name="mneomonic4" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>

                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic5" type="text" />
                         <ErrorMessage name="mneomonic5" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>
 
                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic6" type="text" />
                         <ErrorMessage name="mneomonic6" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>


                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic7" type="text" />
                         <ErrorMessage name="mneomonic7" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>


                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic8" type="text" />
                         <ErrorMessage name="mneomonic8" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>


                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic9" type="text" />
                         <ErrorMessage name="mneomonic9" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>


                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic10" type="text" />
                         <ErrorMessage name="mneomonic10" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>


                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic11" type="text" />
                         <ErrorMessage name="mneomonic11" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>


                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic12" type="text" />
                         <ErrorMessage name="mneomonic12" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>

                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic13" type="text" />
                         <ErrorMessage name="mneomonic13" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>


                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic14" type="text" />
                         <ErrorMessage name="mneomonic14" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>


                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic15" type="text" />
                         <ErrorMessage name="mneomonic15" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>


                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic16" type="text" />
                         <ErrorMessage name="mneomonic16" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>


                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic17" type="text" />
                         <ErrorMessage name="mneomonic17" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>


                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic18" type="text" />
                         <ErrorMessage name="mneomonic18" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>


                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic19" type="text" />
                         <ErrorMessage name="mneomonic19" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>



                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic20" type="text" />
                         <ErrorMessage name="mneomonic20" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>


                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic21" type="text" />
                         <ErrorMessage name="mneomonic21" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>



                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield" as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic22" type="text" />
                         <ErrorMessage name="mneomonic22" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>



                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic23" type="text" />
                         <ErrorMessage name="mneomonic23" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>


                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic24" type="text" />
                         <ErrorMessage name="mneomonic24" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>

                         <Grid item lg={2.2} md={2.2} sm={3.5} xs={5.5}>
                         <Field className="customOptintextfield"  as={TextField} sx={{'& .MuiInputBase-root': { minWidth: 0,padding:"5px 15px !important"} ,minwidth:"50px"}}  name="mneomonic25" type="text" />
                         <ErrorMessage name="mneomonic25" component="div" style={{ color: 'red', fontSize: '12px', marginTop: '4px' }} />              
                         </Grid>

                        </Grid>
                        </Stack>



                            

                      

                        <Stack direction={'row'} sx={{pt:'14px'}} justifyContent='center' alignItems={'center'} spacing={1}>
                            <Button type='submit' variant="outlined" >Submit</Button>
                            <Button  variant="outlined"  onClick={()=>onClose()}>Cancel</Button>

                        </Stack>


                    </Stack>
                    
                
            </Form>
           </FormikProvider>
            <Stack flexDirection={"row"} justifyContent={"center"}>
                <Box sx={{my:3,width:"35%",height:1.2,bgcolor:"#000"}} />
                <Box sx={{m:1.5, fontSize: '1.2rem',color:"#000",fontFamily:"tiko"}}>OR</Box>
                <Box sx={{my:3,width:"35%",height:1.2,bgcolor:"#000"}} />
            </Stack>
            <Stack sx={{}} direction={"row"} justifyContent={"center"}>       
                <Button onClick={()=>setOpen(true)} variant="contained" sx={{px:3,}}>
                <NoteAddOutlinedIcon sx={{mr:0.5}}/>
                <Typography sx={{ml:0.5}}>Upload Mnemonic File</Typography>
                </Button>
            </Stack>
        </Stack>
        <Box sx={{ mt: 3, p: 2, bgcolor: "#f8f9fa", borderRadius: 2, border: "1px solid #e9ecef" }}>
            <Typography 
                variant="body2" 
                sx={{
                    textAlign: "center",
                    fontSize: "14px",
                    color: "#2D2F39",
                    lineHeight: 1.5,
                    fontWeight: 500
                }}
            >
                <strong>Note:</strong> You only need to opt-in once per asset from a specific DLT Account. 
                All future transactions involving the same asset will automatically be credited—no additional opt-in required.
            </Typography>
        </Box>
    </Box>
  )
}


